export const buttonSizes = {
   ['ExtraSmall']: {
      typography: 'text-xs-semibold',
      padding: 'py-6px px-12px',
      leftIconMargin: 'mr-8px',
      rightIconMargin: 'ml-8px',
      borderRadius: 'border-none'
   },
   ['Small']: {
      typography: 'text-sm-semibold',
      padding: 'py-8px px-14px',
      leftIconMargin: 'mr-8px',
      rightIconMargin: 'ml-8px',
      borderRadius: 'rounded-lg'
   },
   ['Medium']: {
      typography: 'text-sm-semibold',
      padding: 'py-10px px-16px',
      leftIconMargin: 'mr-8px',
      rightIconMargin: 'ml-8px',
      borderRadius: 'rounded-lg'
   },
   ['Large']: {
      typography: 'text-md-semibold',
      padding: 'py-10px px-18px',
      leftIconMargin: 'mr-8px',
      rightIconMargin: 'ml-8px',
      borderRadius: 'rounded-10px'
   },
   ['ExtraLarge']: {
      typography: 'text-md-semibold',
      padding: 'py-12px px-20px',
      leftIconMargin: 'mr-8px',
      rightIconMargin: 'ml-8px',
      borderRadius: 'rounded-10px'
   },
   ['DoubleExtraLarge']: {
      typography: 'text-lg-semibold',
      padding: 'py-16px px-28px',
      leftIconMargin: 'mr-12px',
      rightIconMargin: 'ml-12px',
      borderRadius: 'rounded-xl'
   }
}
